import { siteInfo } from '@/mocks/homeMangaData';

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-50">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/40 rounded-full blur-3xl -translate-y-1/3 translate-x-1/4"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/30 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <p className="text-sm md:text-base text-primary-600 font-medium tracking-wide mb-3">
              {siteInfo.preTags}
            </p>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-3">
              {siteInfo.h1}
            </h1>

            <p className="text-base md:text-lg text-primary-500 font-medium mb-5">
              {siteInfo.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              {siteInfo.description}
            </p>

            <div className="flex items-center justify-center lg:justify-start gap-6 md:gap-8 mb-7 flex-wrap">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <p className="font-heading text-xl md:text-2xl font-bold text-primary-600">{stat.value}</p>
                  <p className="text-xs text-foreground-500 mt-0.5">{stat.label}</p>
                </div>
              ))}
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-3 flex-wrap">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-fire-line"></i>
                开始追漫
              </a>
              <a
                href="#about"
                className="inline-flex items-center gap-2 px-6 py-3 border border-foreground-300 text-foreground-700 font-medium rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-information-line"></i>
                了解我们
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20illustration%20of%20floating%20manga%20comic%20panels%20with%20dynamic%20action%20scenes%20Japanese%20Korean%20and%20Chinese%20comic%20art%20styles%20blended%20together%20warm%20golden%20and%20coral%20tones%20soft%20gradient%20background%20stylized%20editorial%20quality%20with%20floating%20pages%20and%20ink%20effects%20harmonious%20composition&width=960&height=720&seq=hero-manga-main&orientation=landscape"
                alt="爱漫画网 - 韩漫推荐日漫大全国漫排行榜主视觉"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}